import {
  GET_COUNTRIES_FAILURE,
  GET_COUNTRIES_REQUEST,
  GET_COUNTRIES_SUCCESS,
} from "./ActionType";

const initialRequest = {
  loading: false,
  error: null,
  countriesResponse: null,
};

export const countryReducer = (state = initialRequest, action) => {
  switch (action.type) {
    case GET_COUNTRIES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_COUNTRIES_SUCCESS:
      return {
        ...state,
        loading: false,
        countriesResponse: action.payload,
        error: null,
      };
    case GET_COUNTRIES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
